// components/OcAppBarView.tsx
import React from "react";
import { AppBar, Box } from "@mui/material";
import { MyHrHeaderBadge } from "my-hr/components";
import {
  MyLeaveAdminHeaderBadge,
  MyLeaveHeaderBadge,
} from "my-leave/components";
import { MyTimeAppbarBadge } from "my-time/components";
import { MyTimesheetAppbarBadge } from "my-timesheet/components";
import { OcAppBarAccountMenu, OcAppBarCounter, OcAvatar } from "oc/components";
import { OcAppBarContractSelect } from "oc/components";
import { getFullname } from "oc/utils";

interface OcAppBarViewProps {
  isMobile: boolean;
  employeeData: any;
  enabled: boolean;
  hasToRefresh: boolean;
  timeToRefresh: number;
  showRefreshDialog: boolean;
  onRefresh: () => void;
  currentVersion: string;
  onLogout: () => void;
}

export const OcAppBarView: React.FC<OcAppBarViewProps> = ({
  isMobile,
  employeeData,
  enabled,
  hasToRefresh,
  timeToRefresh,
  showRefreshDialog,
  onRefresh,
  currentVersion,
  onLogout,
}) => (
  <AppBar
    position="sticky"
    elevation={0}
    id="headerAppBar"
    sx={{ backgroundColor: "#ffffff" }}
  >
    <Box
      height="64px"
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
      paddingRight="18px"
      fontSize="14px"
      letterSpacing="0.25px"
      sx={{ color: "#212121" }}
    >
      <Box paddingLeft="16px">
        {hasToRefresh && !showRefreshDialog && (
          <OcAppBarCounter
            timeToRefresh={timeToRefresh}
            onRefresh={onRefresh}
          />
        )}
      </Box>
      <Box display="flex" flexDirection="row" alignItems="center">
        <Box marginRight="16px" display="flex" flexDirection="row">
          <MyLeaveHeaderBadge />
          <MyLeaveAdminHeaderBadge />
          {enabled && <MyHrHeaderBadge />}
          <MyTimeAppbarBadge />
          <MyTimesheetAppbarBadge />
        </Box>
        <Box
          id="app-bar-menu-container"
          display="flex"
          flexDirection="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          {!isMobile && <OcAppBarContractSelect isMobile={isMobile} />}
          <Box marginRight="16px">
            <OcAvatar
              employee={employeeData?.code}
              style={{ width: "45px", height: "45px" }}
            />
          </Box>
          {!isMobile && (
            <Box marginRight="6px" id="header-app-bar-full-name">
              {getFullname(employeeData)}
            </Box>
          )}
          <OcAppBarAccountMenu
            onLogout={onLogout}
            currentVersion={currentVersion}
            isMobile={isMobile}
          />
        </Box>
      </Box>
    </Box>
  </AppBar>
);

export default OcAppBarView;
